import { AutoUploadNode } from "../AutoUploadNode"
import { OnDemandArt57NodeList } from "./ListEntity/OnDemandArt57NodeList";
import { OnDemandAutoUploadList } from "./ListEntity/OnDemandAutouploadList";

export class OnDemandAutoUploadNode extends AutoUploadNode{
    getOnDemandEntities():any{
        let onDemandEntities: any = {};
        this.children?.forEach((child: any) => {
            if ((child instanceof OnDemandAutoUploadList && child.isLoaded) ||
                (child instanceof OnDemandArt57NodeList)
               ) {
                onDemandEntities = {...onDemandEntities, ...child.getOnDemandEntities()};
            }
        });

        return onDemandEntities;

    }
}